import { Col, Row } from "antd";
import React from "react";
import ConfigureGithubForDataQuality from "./ConfigureGithubForDataQuality";
import ConfigureGithubForModelTraining from "./ConfigureGithubForModelTraining";

const GithubConnection = () => {
  return (
    <div>
      {/* {JSON.stringify(formData)}=========== */}

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ConfigureGithubForDataQuality />
        </Col>
        <Col span={12}>{/* <ConfigureGithubForModelTraining /> */}</Col>
      </Row>
    </div>
  );
};

export default GithubConnection;
